// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Host fills tab pane; overflow visible so autocomplete list can overlay Card 2 */
:host {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  width: 100%;
  overflow: visible;
}

.logs-redistribution-wrap {
  /* Column layout; visible overflow so pipeline suggestions are not clipped in Card 1 */
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: visible;
  box-sizing: border-box;
  /* Card 1 shell: above Card 2 so dropdown stacks on top */
  /* Single-row toolbar; overflow visible so suggestions overlay Card 2 */
  /* Card 2 grows to fill remaining tab height (scroll only in messages-body) */
  /* Card 2 scroll — fills card to bottom of tab; validation list scrolls here */
  /* Compact ID field on the same row as pipeline */
  /* Dropdown paints over Card 2 (higher z-index than messages-card) */
  /* Copy icon just left of autocomplete clear (X); z-index above input (9998) but below dropdown (10050) */
}
.logs-redistribution-wrap .redistribution-req {
  font-size: 6px;
  position: relative;
  top: -2px;
}
.logs-redistribution-wrap .redistribution-search-card {
  flex: 0 0 auto;
  overflow: visible;
  position: relative;
  z-index: 2;
}
.logs-redistribution-wrap .redistribution-search-card-pipeline {
  overflow: visible;
  position: relative;
  z-index: 3;
}
.logs-redistribution-wrap .redistribution-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  overflow: visible;
}
.logs-redistribution-wrap .redistribution-toolbar-field {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  min-width: 0;
}
.logs-redistribution-wrap .redistribution-toolbar-label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  font-weight: 600;
}
.logs-redistribution-wrap .redistribution-toolbar-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}
.logs-redistribution-wrap .redistribution-messages-card {
  flex: 1 1 auto;
  margin-top: 0;
  overflow: hidden;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}
.logs-redistribution-wrap .redistribution-messages-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}
.logs-redistribution-wrap .redistribution-messages-header {
  flex: 0 0 auto;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e8e8;
}
.logs-redistribution-wrap .redistribution-messages-empty {
  font-size: 12px;
  color: #777;
  padding: 8px 4px;
}
.logs-redistribution-wrap .redistribution-toolbar-pipeline .redistribution-pipeline-wrap,
.logs-redistribution-wrap .redistribution-toolbar-pipeline .redistribution-pipeline-wrap.ng-autocompleteroutr {
  position: relative;
  width: 370px;
  max-width: 370px;
  float: none;
  overflow: visible;
  z-index: 20;
}
.logs-redistribution-wrap .redistribution-toolbar-id .redistribution-id-input-wrap {
  width: 260px;
  max-width: 260px;
  flex-shrink: 0;
}
.logs-redistribution-wrap .redistribution-pipeline-wrap ::ng-deep .autocomplete-container {
  position: relative !important;
  overflow: visible !important;
  z-index: 9998;
}
.logs-redistribution-wrap .redistribution-pipeline-wrap ::ng-deep .autocomplete-container.active {
  z-index: 9999 !important;
}
.logs-redistribution-wrap .redistribution-pipeline-wrap ::ng-deep .autocomplete-container .suggestions-container {
  position: absolute !important;
  top: calc(100% + 2px) !important;
  left: 0 !important;
  width: 100% !important;
  max-height: min(280px, 32vh);
  z-index: 10050 !important;
  overflow: hidden !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  background: #fff;
}
.logs-redistribution-wrap .redistribution-pipeline-wrap ::ng-deep .autocomplete-container .suggestions-container ul {
  max-height: min(280px, 32vh) !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}
.logs-redistribution-wrap .redistribution-pipeline-wrap ::ng-deep .autocomplete-container .input-container input {
  /* Room for copy icon + autocomplete clear (X) */
  padding-right: 52px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.logs-redistribution-wrap ::ng-deep .pipeline_feild.pipleline_input .autocomplete-container {
  width: 100% !important;
}
.logs-redistribution-wrap ::ng-deep .pipeline_feild.pipleline_input .autocomplete-container .input-container input {
  box-shadow: 0 1px 1px #959595 !important;
  height: 30px !important;
  border: transparent !important;
  border-radius: 5px !important;
  width: 100% !important;
  padding-right: 52px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.logs-redistribution-wrap .redistribution-pipeline-wrap .redistribution-pipeline-copy {
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  font-size: 18px;
  line-height: 22px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  z-index: 10000;
  pointer-events: auto;
}
.logs-redistribution-wrap .redistribution-input-uniform {
  height: 36px !important;
  box-shadow: 0 1px 1px #959595;
  background: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.logs-redistribution-wrap .redistribution-input-uniform .eventselecttypeControl {
  height: 34px !important;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 11px !important;
}

.redistribution-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.redistribution-modal {
  background: #fff;
  border-radius: 6px;
  width: 420px;
  max-width: 95vw;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.redistribution-modal .redistribution-modal-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
}
.redistribution-modal .redistribution-modal-body {
  padding: 16px;
}
.redistribution-modal .redistribution-modal-body label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
}
.redistribution-modal .redistribution-modal-body label.redistribution-modal-label {
  margin-bottom: 10px;
}
.redistribution-modal .redistribution-modal-footer {
  padding: 10px 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
}
.redistribution-modal .redistribution-reason-textarea {
  width: 100%;
  font-size: 12px;
  resize: vertical;
  border-radius: 4px;
}

.redistribution-result-item {
  border-left: 3px solid;
  padding: 6px 12px;
  margin-bottom: 4px;
  font-size: 12px;
}

.redistribution-result-success {
  border-left-color: #28a745;
  background: #f0faf3;
}

.redistribution-success-table-wrap {
  padding: 8px 12px;
}

/* Autocomplete-selected pipeline — highlighted in valid + success tables */
.redistribution-input-pipeline-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  margin-right: 6px;
  padding: 1px 6px;
  border-radius: 3px;
  background: #17a2b8;
  color: #fff;
  vertical-align: middle;
}

.redistribution-input-pipeline-name {
  font-weight: 600;
  color: #0c5460;
}

.redistribution-input-pipeline-row {
  background: #e8f4fd;
}

.redistribution-pipeline-table-valid .redistribution-input-pipeline-row td {
  border-bottom-color: #cce5f5;
}

.redistribution-success-input-row {
  background: #e8f4fd;
}
.redistribution-success-input-row .redistribution-pipeline-name {
  font-weight: 600;
}

.redistribution-success-table {
  margin: 0;
  /* Success table: text left, copy icon right — same layout for Pipeline name and Transaction ID. */
  /* Fixed width on the Pipeline name cell so the copy icon (pushed to the right edge
     via space-between) lands on the same x-position on every row — including rows with
     the "Input pipeline" badge, which otherwise vary in width and look jagged. */
  /* Transaction ID: keep the icon right after the (fixed-width monospace) value,
     not pushed to the far cell edge. */
}
.redistribution-success-table .redistribution-success-id {
  font-weight: 600;
  white-space: nowrap;
  vertical-align: top;
}
.redistribution-success-table .redistribution-success-txn {
  font-family: monospace;
  font-size: 10px;
  font-weight: 700;
  word-break: break-all;
  vertical-align: top;
}
.redistribution-success-table .redistribution-pipeline-name {
  vertical-align: top;
}
.redistribution-success-table .redistribution-pipeline-name {
  width: 320px;
  max-width: 320px;
}
.redistribution-success-table .redistribution-pipeline-name .redistribution-txn-row {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.redistribution-success-table .redistribution-success-txn .redistribution-txn-row {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}
.redistribution-success-table .redistribution-success-pipeline-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  word-break: break-word;
}
.redistribution-success-table .redistribution-success-txn-text {
  min-width: 0;
  word-break: break-word;
}
.redistribution-success-table .redistribution-result-copy {
  flex-shrink: 0;
  margin-left: 0;
  align-self: center;
}

.redistribution-result-valid {
  border-left-color: #28a745;
  background: #f0faf3;
  color: #1e7e34;
}

.redistribution-result-invalid {
  border-left-color: #dc3545;
  background: #fdf3f4;
  color: #c82333;
}

/* SP returned pipelines but not the selected one — user may click Proceed */
.redistribution-result-proceed {
  border-left-color: #ffc107;
  background: #fffbf0;
  color: #856404;
}

.redistribution-disclaimer {
  border-left-color: #17a2b8;
  background: #f0f9fc;
  color: #0c5460;
}

.redistribution-pipeline-table-wrap {
  margin: 8px 0 0 22px;
  max-height: 200px;
  overflow-y: auto;
  overscroll-behavior: contain;
  /* Above sibling rows in Card 2; autocomplete overlay is cleared on Validate/Proceed. */
  position: relative;
  z-index: 2;
}

.redistribution-pipeline-list-title {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 600;
}

/* Helper line under validation status — explains optional pipeline selection */
.redistribution-pipeline-list-helper {
  margin: 6px 0 4px;
  font-size: 11px;
  line-height: 1.45;
}

.redistribution-pipeline-included-mark {
  display: inline-block;
  width: 14px;
  text-align: center;
  color: #1e7e34;
  font-weight: 700;
}

.redistribution-pipeline-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}
.redistribution-pipeline-table th {
  text-align: left;
  font-weight: 600;
  padding: 4px 8px;
  border-bottom: 1px solid #e0e0e0;
  background: rgba(255, 255, 255, 0.6);
}
.redistribution-pipeline-table td {
  padding: 6px 8px;
  vertical-align: top;
  border-bottom: 1px solid #f0f0f0;
}
.redistribution-pipeline-table .redistribution-pipeline-check-col {
  width: 32px;
  text-align: center;
  white-space: nowrap;
}
.redistribution-pipeline-table .redistribution-pipeline-name {
  min-width: 120px;
  word-break: break-word;
  padding-right: 8px;
}
.redistribution-pipeline-table .redistribution-pipeline-meta {
  min-width: 72px;
  word-break: break-word;
  color: #555;
}

.redistribution-pipeline-table-proceed {
  /* Ensure checkbox hit target receives clicks inside scrollable Proceed table. */
}
.redistribution-pipeline-table-proceed th.redistribution-pipeline-check-col,
.redistribution-pipeline-table-proceed td.redistribution-pipeline-check-col {
  vertical-align: middle;
}
.redistribution-pipeline-table-proceed .redistribution-pipeline-check-col input[type=checkbox] {
  pointer-events: auto;
  cursor: pointer;
}

/* Inline copy icon in Card 2 rows (pipeline id + transaction id) */
.redistribution-result-copy {
  width: 16px;
  height: 16px;
  font-size: 14px;
  line-height: 16px;
  margin-left: 6px;
  vertical-align: middle;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);
  display: inline-flex;
}
.redistribution-result-copy:hover {
  color: rgba(0, 0, 0, 0.7);
}

.redistribution-txn-row {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
}

/* Bulk copy icon in success table Transaction ID column header */
.redistribution-success-txn-header {
  white-space: nowrap;
}

/* Bulk copy icon in success table Pipeline name column header */
.redistribution-success-pipeline-header {
  white-space: nowrap;
}

.redistribution-success-bulk-copy {
  margin-left: 4px;
  vertical-align: middle;
}

.redistribution-pipeline-grouped-wrap {
  margin-left: 0;
  max-height: 280px;
}

.redistribution-pipeline-table-grouped {
  /* Enhancement: widen IDs column to fit 3 chips per row; trim meta columns to free space. */
}
.redistribution-pipeline-table-grouped .redistribution-pipeline-ids-col {
  min-width: 260px;
  max-width: 360px;
}
.redistribution-pipeline-table-grouped .redistribution-pipeline-meta {
  max-width: 130px;
}

.redistribution-id-chip-list {
  /* Enhancement: 3 IDs per row (wrap) instead of one ID per row. */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px 10px;
}

.redistribution-id-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  margin: 0;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.5);
  /* Enhancement: each chip ~1/3 of the column so 3 fit per row. */
  flex: 0 0 calc(33.333% - 10px);
  max-width: calc(33.333% - 10px);
}
.redistribution-id-chip input[type=checkbox] {
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.redistribution-id-chip-valid .redistribution-id-chip-label {
  color: #1e7e34;
}

.redistribution-id-chip-proceed .redistribution-id-chip-label {
  color: #856404;
}

.redistribution-id-chip-invalid {
  background: #fdf3f4;
}
.redistribution-id-chip-invalid .redistribution-id-chip-label {
  color: #c82333;
  font-weight: 600;
}

.redistribution-id-chip-label {
  word-break: break-all;
}

/* Enhancement: rule disclaimer shown above the success transaction table. */
.redistribution-success-rule-note {
  margin-bottom: 8px;
  font-size: 12px;
  color: #0c5460;
}

.redistribution-result-line {
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/app/logs/redistribution/log-redistribution.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,kFAAA;AACA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAGA;EACE,sFAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EAQA,yDAAA;EAQA,uEAAA;EAuCA,6EAAA;EAaA,8EAAA;EAgCA,iDAAA;EAiBA,oEAAA;EA8CA,yGAAA;AA5JF;AALE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;AAOJ;AAHE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAKJ;AADE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;AAGJ;AAAE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AACJ;AAEE;EACE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AADJ;AAKE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAHJ;AAOE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;AALJ;AAQE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AANJ;AASE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAPJ;AAUE;;EAEE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AARJ;AAYE;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AAVJ;AAaE;EACE,6BAAA;EACA,4BAAA;EACA,aAAA;AAXJ;AAcE;EACE,wBAAA;AAZJ;AAgBE;EACE,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,uCAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,gDAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAhBJ;AAmBE;EACE,sBAAA;AAjBJ;AAmBI;EACE,wCAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAjBN;AAsBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,oBAAA;AApBJ;AAuBE;EACE,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AArBJ;AAuBI;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,0BCpNS;AD+Lf;;AA2BA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBF;;AA2BA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;AAxBF;AA0BE;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;AAxBJ;AA2BE;EACE,aAAA;AAzBJ;AA2BI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAzBN;AA4BI;EACE,mBAAA;AA1BN;AA8BE;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA7BJ;;AAiCA;EACE,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,0BAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,iBAAA;AA9BF;;AAiCA,2EAAA;AACA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,gBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,mBAAA;AA9BF;;AAiCA;EACE,4BAAA;AA9BF;;AAiCA;EACE,mBAAA;AA9BF;AAgCE;EACE,gBAAA;AA9BJ;;AAkCA;EACE,SAAA;EAgBA,kGAAA;EAKA;;iFAAA;EAgBA;uCAAA;AA9DF;AA2BE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AA1BJ;AA8BE;EACE,mBAAA;AA5BJ;AAkCE;EACE,YAAA;EACA,gBAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAhCN;AAsCE;EACE,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;AApCJ;AAuCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;AArCJ;AAwCE;EACE,YAAA;EACA,sBAAA;AAtCJ;AAyCE;EACE,cAAA;EACA,cAAA;EACA,kBAAA;AAvCJ;;AA2CA;EACE,0BAAA;EACA,mBAAA;EACA,cAAA;AAxCF;;AA2CA;EACE,0BAAA;EACA,mBAAA;EACA,cAAA;AAxCF;;AA2CA,4EAAA;AACA;EACE,0BAAA;EACA,mBAAA;EACA,cAAA;AAxCF;;AA2CA;EACE,0BAAA;EACA,mBAAA;EACA,cAAA;AAxCF;;AA2CA;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,uFAAA;EACA,kBAAA;EACA,UAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAxCF;;AA2CA,+EAAA;AACA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;AAxCF;;AA2CA;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAxCF;AA0CE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,oCAAA;AAxCJ;AA2CE;EACE,gBAAA;EACA,mBAAA;EACA,gCAAA;AAzCJ;AA4CE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;AA3CJ;AA8CE;EACE,eAAA;EACA,sBAAA;EACA,WAAA;AA5CJ;;AAgDA;EAME,gFAAA;AAlDF;AA6CE;;EAEE,sBAAA;AA3CJ;AA+CE;EACE,oBAAA;EACA,eAAA;AA7CJ;;AAiDA,mEAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;AA9CF;AAgDE;EACE,yBAAA;AA9CJ;;AAkDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA/CF;;AAkDA,iEAAA;AACA;EACE,mBAAA;AA/CF;;AAkDA,gEAAA;AACA;EACE,mBAAA;AA/CF;;AAkDA;EACE,gBAAA;EACA,sBAAA;AA/CF;;AAkDA;EACE,cAAA;EACA,iBAAA;AA/CF;;AAkDA;EACE,2FAAA;AA/CF;AAgDE;EACE,gBAAA;EACA,gBAAA;AA9CJ;AAiDE;EACE,gBAAA;AA/CJ;;AAmDA;EACE,iEAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAhDF;;AAmDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gEAAA;EACA,8BAAA;EACA,+BAAA;AAhDF;AAkDE;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAhDJ;;AAoDA;EACE,cAAA;AAjDF;;AAoDA;EACE,cAAA;AAjDF;;AAoDA;EACE,mBAAA;AAjDF;AAmDE;EACE,cAAA;EACA,gBAAA;AAjDJ;;AAqDA;EACE,qBAAA;AAlDF;;AAqDA,4EAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AAlDF;;AAqDA;EACE,cAAA;AAlDF","sourcesContent":["@import \"../../../variables.scss\";\r\n\r\n/* Host fills tab pane; overflow visible so autocomplete list can overlay Card 2 */\r\n:host {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  overflow: visible;\r\n}\r\n\r\n.logs-redistribution-wrap {\r\n  /* Column layout; visible overflow so pipeline suggestions are not clipped in Card 1 */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  overflow: visible;\r\n  box-sizing: border-box;\r\n\r\n  .redistribution-req {\r\n    font-size: 6px;\r\n    position: relative;\r\n    top: -2px;\r\n  }\r\n\r\n  /* Card 1 shell: above Card 2 so dropdown stacks on top */\r\n  .redistribution-search-card {\r\n    flex: 0 0 auto;\r\n    overflow: visible;\r\n    position: relative;\r\n    z-index: 2;\r\n  }\r\n\r\n  /* Single-row toolbar; overflow visible so suggestions overlay Card 2 */\r\n  .redistribution-search-card-pipeline {\r\n    overflow: visible;\r\n    position: relative;\r\n    z-index: 3;\r\n  }\r\n\r\n  .redistribution-toolbar {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 8px 12px;\r\n    overflow: visible;\r\n  }\r\n\r\n  .redistribution-toolbar-field {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    flex: 0 0 auto;\r\n    min-width: 0;\r\n  }\r\n\r\n  .redistribution-toolbar-label {\r\n    margin: 0;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .redistribution-toolbar-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    margin-left: auto;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  /* Card 2 grows to fill remaining tab height (scroll only in messages-body) */\r\n  .redistribution-messages-card {\r\n    flex: 1 1 auto;\r\n    margin-top: 0;\r\n    overflow: hidden;\r\n    position: relative;\r\n    z-index: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 0;\r\n    height: 100%;\r\n  }\r\n\r\n  /* Card 2 scroll — fills card to bottom of tab; validation list scrolls here */\r\n  .redistribution-messages-body {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    overscroll-behavior: contain;\r\n  }\r\n\r\n  .redistribution-messages-header {\r\n    flex: 0 0 auto;\r\n    margin-bottom: 8px;\r\n    padding-bottom: 6px;\r\n    border-bottom: 1px solid #e8e8e8;\r\n  }\r\n\r\n  .redistribution-messages-empty {\r\n    font-size: 12px;\r\n    color: #777;\r\n    padding: 8px 4px;\r\n  }\r\n\r\n  .redistribution-toolbar-pipeline .redistribution-pipeline-wrap,\r\n  .redistribution-toolbar-pipeline .redistribution-pipeline-wrap.ng-autocompleteroutr {\r\n    position: relative;\r\n    width: 370px;\r\n    max-width: 370px;\r\n    float: none;\r\n    overflow: visible;\r\n    z-index: 20;\r\n  }\r\n\r\n  /* Compact ID field on the same row as pipeline */\r\n  .redistribution-toolbar-id .redistribution-id-input-wrap {\r\n    width: 260px;\r\n    max-width: 260px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .redistribution-pipeline-wrap ::ng-deep .autocomplete-container {\r\n    position: relative !important;\r\n    overflow: visible !important;\r\n    z-index: 9998;\r\n  }\r\n\r\n  .redistribution-pipeline-wrap ::ng-deep .autocomplete-container.active {\r\n    z-index: 9999 !important;\r\n  }\r\n\r\n  /* Dropdown paints over Card 2 (higher z-index than messages-card) */\r\n  .redistribution-pipeline-wrap ::ng-deep .autocomplete-container .suggestions-container {\r\n    position: absolute !important;\r\n    top: calc(100% + 2px) !important;\r\n    left: 0 !important;\r\n    width: 100% !important;\r\n    max-height: min(280px, 32vh);\r\n    z-index: 10050 !important;\r\n    overflow: hidden !important;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\r\n    border-radius: 5px;\r\n    background: #fff;\r\n  }\r\n\r\n  .redistribution-pipeline-wrap ::ng-deep .autocomplete-container .suggestions-container ul {\r\n    max-height: min(280px, 32vh) !important;\r\n    overflow-y: auto !important;\r\n    overscroll-behavior: contain;\r\n    -webkit-overflow-scrolling: touch;\r\n    background: #fff;\r\n  }\r\n\r\n  .redistribution-pipeline-wrap ::ng-deep .autocomplete-container .input-container input {\r\n    /* Room for copy icon + autocomplete clear (X) */\r\n    padding-right: 52px !important;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  ::ng-deep .pipeline_feild.pipleline_input .autocomplete-container {\r\n    width: 100% !important;\r\n\r\n    .input-container input {\r\n      box-shadow: 0 1px 1px #959595 !important;\r\n      height: 30px !important;\r\n      border: transparent !important;\r\n      border-radius: 5px !important;\r\n      width: 100% !important;\r\n      padding-right: 52px !important;\r\n      text-overflow: ellipsis;\r\n      overflow: hidden;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n\r\n  /* Copy icon just left of autocomplete clear (X); z-index above input (9998) but below dropdown (10050) */\r\n  .redistribution-pipeline-wrap .redistribution-pipeline-copy {\r\n    position: absolute;\r\n    right: 28px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 22px;\r\n    height: 22px;\r\n    font-size: 18px;\r\n    line-height: 22px;\r\n    cursor: pointer;\r\n    color: rgba(0, 0, 0, 0.54);\r\n    z-index: 10000;\r\n    pointer-events: auto;\r\n  }\r\n\r\n  .redistribution-input-uniform {\r\n    height: 36px !important;\r\n    box-shadow: 0 1px 1px #959595;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 10px;\r\n\r\n    .eventselecttypeControl {\r\n      height: 34px !important;\r\n      width: 100%;\r\n      border: none;\r\n      outline: none;\r\n      background: transparent;\r\n      font-size: $inputfontsize;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.redistribution-modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  z-index: 1050;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.redistribution-modal {\r\n  background: #fff;\r\n  border-radius: 6px;\r\n  width: 420px;\r\n  max-width: 95vw;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);\r\n\r\n  .redistribution-modal-header {\r\n    padding: 12px 16px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .redistribution-modal-body {\r\n    padding: 16px;\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 8px;\r\n      font-size: 12px;\r\n    }\r\n\r\n    label.redistribution-modal-label {\r\n      margin-bottom: 10px;\r\n    }\r\n  }\r\n\r\n  .redistribution-modal-footer {\r\n    padding: 10px 16px;\r\n    border-top: 1px solid #e0e0e0;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .redistribution-reason-textarea {\r\n    width: 100%;\r\n    font-size: 12px;\r\n    resize: vertical;\r\n    border-radius: 4px;\r\n  }\r\n}\r\n\r\n.redistribution-result-item {\r\n  border-left: 3px solid;\r\n  padding: 6px 12px;\r\n  margin-bottom: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.redistribution-result-success {\r\n  border-left-color: #28a745;\r\n  background: #f0faf3;\r\n}\r\n\r\n.redistribution-success-table-wrap {\r\n  padding: 8px 12px;\r\n}\r\n\r\n/* Autocomplete-selected pipeline — highlighted in valid + success tables */\r\n.redistribution-input-pipeline-badge {\r\n  display: inline-block;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  margin-right: 6px;\r\n  padding: 1px 6px;\r\n  border-radius: 3px;\r\n  background: #17a2b8;\r\n  color: #fff;\r\n  vertical-align: middle;\r\n}\r\n\r\n.redistribution-input-pipeline-name {\r\n  font-weight: 600;\r\n  color: #0c5460;\r\n}\r\n\r\n.redistribution-input-pipeline-row {\r\n  background: #e8f4fd;\r\n}\r\n\r\n.redistribution-pipeline-table-valid .redistribution-input-pipeline-row td {\r\n  border-bottom-color: #cce5f5;\r\n}\r\n\r\n.redistribution-success-input-row {\r\n  background: #e8f4fd;\r\n\r\n  .redistribution-pipeline-name {\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.redistribution-success-table {\r\n  margin: 0;\r\n\r\n  .redistribution-success-id {\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    vertical-align: top;\r\n  }\r\n\r\n  .redistribution-success-txn {\r\n    font-family: monospace;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    word-break: break-all;\r\n    vertical-align: top;\r\n  }\r\n\r\n  /* Success table: text left, copy icon right — same layout for Pipeline name and Transaction ID. */\r\n  .redistribution-pipeline-name {\r\n    vertical-align: top;\r\n  }\r\n\r\n  /* Fixed width on the Pipeline name cell so the copy icon (pushed to the right edge\r\n     via space-between) lands on the same x-position on every row — including rows with\r\n     the \"Input pipeline\" badge, which otherwise vary in width and look jagged. */\r\n  .redistribution-pipeline-name {\r\n    width: 320px;\r\n    max-width: 320px;\r\n\r\n    .redistribution-txn-row {\r\n      display: flex;\r\n      width: 100%;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 6px;\r\n    }\r\n  }\r\n\r\n  /* Transaction ID: keep the icon right after the (fixed-width monospace) value,\r\n     not pushed to the far cell edge. */\r\n  .redistribution-success-txn .redistribution-txn-row {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 6px;\r\n  }\r\n\r\n  .redistribution-success-pipeline-text {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    min-width: 0;\r\n    word-break: break-word;\r\n  }\r\n\r\n  .redistribution-success-txn-text {\r\n    min-width: 0;\r\n    word-break: break-word;\r\n  }\r\n\r\n  .redistribution-result-copy {\r\n    flex-shrink: 0;\r\n    margin-left: 0;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n.redistribution-result-valid {\r\n  border-left-color: #28a745;\r\n  background: #f0faf3;\r\n  color: #1e7e34;\r\n}\r\n\r\n.redistribution-result-invalid {\r\n  border-left-color: #dc3545;\r\n  background: #fdf3f4;\r\n  color: #c82333;\r\n}\r\n\r\n/* SP returned pipelines but not the selected one — user may click Proceed */\r\n.redistribution-result-proceed {\r\n  border-left-color: #ffc107;\r\n  background: #fffbf0;\r\n  color: #856404;\r\n}\r\n\r\n.redistribution-disclaimer {\r\n  border-left-color: #17a2b8;\r\n  background: #f0f9fc;\r\n  color: #0c5460;\r\n}\r\n\r\n.redistribution-pipeline-table-wrap {\r\n  margin: 8px 0 0 22px;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n  /* Above sibling rows in Card 2; autocomplete overlay is cleared on Validate/Proceed. */\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.redistribution-pipeline-list-title {\r\n  margin: 0 0 6px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Helper line under validation status — explains optional pipeline selection */\r\n.redistribution-pipeline-list-helper {\r\n  margin: 6px 0 4px;\r\n  font-size: 11px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.redistribution-pipeline-included-mark {\r\n  display: inline-block;\r\n  width: 14px;\r\n  text-align: center;\r\n  color: #1e7e34;\r\n  font-weight: 700;\r\n}\r\n\r\n.redistribution-pipeline-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 11px;\r\n\r\n  th {\r\n    text-align: left;\r\n    font-weight: 600;\r\n    padding: 4px 8px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    background: rgba(255, 255, 255, 0.6);\r\n  }\r\n\r\n  td {\r\n    padding: 6px 8px;\r\n    vertical-align: top;\r\n    border-bottom: 1px solid #f0f0f0;\r\n  }\r\n\r\n  .redistribution-pipeline-check-col {\r\n    width: 32px;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .redistribution-pipeline-name {\r\n    min-width: 120px;\r\n    word-break: break-word;\r\n    padding-right: 8px;\r\n  }\r\n\r\n  .redistribution-pipeline-meta {\r\n    min-width: 72px;\r\n    word-break: break-word;\r\n    color: #555;\r\n  }\r\n}\r\n\r\n.redistribution-pipeline-table-proceed {\r\n  th.redistribution-pipeline-check-col,\r\n  td.redistribution-pipeline-check-col {\r\n    vertical-align: middle;\r\n  }\r\n\r\n  /* Ensure checkbox hit target receives clicks inside scrollable Proceed table. */\r\n  .redistribution-pipeline-check-col input[type=\"checkbox\"] {\r\n    pointer-events: auto;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n/* Inline copy icon in Card 2 rows (pipeline id + transaction id) */\r\n.redistribution-result-copy {\r\n  width: 16px;\r\n  height: 16px;\r\n  font-size: 14px;\r\n  line-height: 16px;\r\n  margin-left: 6px;\r\n  vertical-align: middle;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.45);\r\n  display: inline-flex;\r\n\r\n  &:hover {\r\n    color: rgba(0, 0, 0, 0.7);\r\n  }\r\n}\r\n\r\n.redistribution-txn-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 2px;\r\n}\r\n\r\n/* Bulk copy icon in success table Transaction ID column header */\r\n.redistribution-success-txn-header {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Bulk copy icon in success table Pipeline name column header */\r\n.redistribution-success-pipeline-header {\r\n  white-space: nowrap;\r\n}\r\n\r\n.redistribution-success-bulk-copy {\r\n  margin-left: 4px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.redistribution-pipeline-grouped-wrap {\r\n  margin-left: 0;\r\n  max-height: 280px;\r\n}\r\n\r\n.redistribution-pipeline-table-grouped {\r\n  /* Enhancement: widen IDs column to fit 3 chips per row; trim meta columns to free space. */\r\n  .redistribution-pipeline-ids-col {\r\n    min-width: 260px;\r\n    max-width: 360px;\r\n  }\r\n\r\n  .redistribution-pipeline-meta {\r\n    max-width: 130px;\r\n  }\r\n}\r\n\r\n.redistribution-id-chip-list {\r\n  /* Enhancement: 3 IDs per row (wrap) instead of one ID per row. */\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  gap: 4px 10px;\r\n}\r\n\r\n.redistribution-id-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 11px;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  padding: 2px 4px;\r\n  border-radius: 3px;\r\n  background: rgba(255, 255, 255, 0.5);\r\n  /* Enhancement: each chip ~1/3 of the column so 3 fit per row. */\r\n  flex: 0 0 calc(33.333% - 10px);\r\n  max-width: calc(33.333% - 10px);\r\n\r\n  input[type=\"checkbox\"] {\r\n    margin: 0;\r\n    cursor: pointer;\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n.redistribution-id-chip-valid .redistribution-id-chip-label {\r\n  color: #1e7e34;\r\n}\r\n\r\n.redistribution-id-chip-proceed .redistribution-id-chip-label {\r\n  color: #856404;\r\n}\r\n\r\n.redistribution-id-chip-invalid {\r\n  background: #fdf3f4;\r\n\r\n  .redistribution-id-chip-label {\r\n    color: #c82333;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.redistribution-id-chip-label {\r\n  word-break: break-all;\r\n}\r\n\r\n/* Enhancement: rule disclaimer shown above the success transaction table. */\r\n.redistribution-success-rule-note {\r\n  margin-bottom: 8px;\r\n  font-size: 12px;\r\n  color: #0c5460;\r\n}\r\n\r\n.redistribution-result-line {\r\n  color: inherit;\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
